export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20curated%20fashion%20and%20lifestyle%20objects%20including%20linen%20fabric%20swatches%20ceramic%20vessels%20dried%20botanicals%20and%20minimalist%20accessories%20arranged%20in%20an%20organic%20spiral%20composition%20on%20warm%20cream%20surface%2C%20soft%20directional%20natural%20light%20from%20upper%20left%2C%20editorial%20still%20life%20photography%2C%20earthy%20neutral%20color%20palette%20of%20sand%20terracotta%20sage%20and%20warm%20ivory%20tones%2C%20sophisticated%20gallery%20aesthetic%2C%20harmonious%20balanced%20negative%20space&width=1600&height=900&seq=hero-bg-v2&orientation=landscape"
          alt="Superbuy Spreadsheet product research and curated fashion items artistic flat lay"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark overlay for text contrast */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/30 to-black/20"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full max-w-[1440px] mx-auto px-4 md:px-8 flex items-end pb-12 md:pb-16 pt-20 md:pt-0">
        <div className="w-full flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          {/* Left text */}
          <div className="max-w-2xl">
            <div className="inline-block px-3 py-1.5 rounded-full border border-background-50/30 text-background-50/90 text-xs md:text-sm font-medium mb-4 md:mb-5">
              2026 Updated Guide
            </div>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight">
              Superbuy Spreadsheet
              <br />
              <span className="font-light text-background-50/85">The Ultimate Tool For Smarter Product Research</span>
            </h1>
            <p className="mt-4 md:mt-5 text-sm md:text-base text-background-50/75 max-w-lg leading-relaxed">
              Discover how Superbuy Spreadsheet helps shoppers organize products, compare prices, track purchases, and build a faster, safer shopping workflow.
            </p>
          </div>

          {/* Right CTAs */}
          <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:min-w-[200px]">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-colors text-center cursor-pointer whitespace-nowrap"
            >
              Explore Superbuy Spreadsheet Guide
              <i className="ri-arrow-right-line ml-2 text-xs"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 rounded-full border border-background-50/50 text-background-50 text-sm md:text-base font-medium hover:bg-white/10 transition-colors text-center cursor-pointer whitespace-nowrap"
            >
              Visit Our Main Platform
            </a>
          </div>
        </div>
      </div>

      {/* Trust badges */}
      <div className="absolute bottom-4 md:bottom-6 right-4 md:right-8 z-10 flex items-center gap-3 md:gap-4 flex-wrap justify-end max-w-[75%]">
        {['Updated 2026 Guide', 'Beginner Friendly', 'Complete Tutorials', 'Security Focused'].map((badge) => (
          <span key={badge} className="flex items-center gap-1.5 text-xs text-background-50/70 whitespace-nowrap">
            <i className="ri-check-line text-primary-400 text-xs"></i>
            {badge}
          </span>
        ))}
      </div>
    </section>
  );
}